export var McfunctionNode;
(function (McfunctionNode) {
    /* istanbul ignore next */
    function is(node) {
        return node?.type === 'mcfunction:entry';
    }
    McfunctionNode.is = is;
})(McfunctionNode || (McfunctionNode = {}));
//# sourceMappingURL=entry.js.map